export default "__VITE_ASSET__Bs0EGu3A__"